/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDeleteUserInviteRequest
 */
export interface ControlDeleteUserInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlDeleteUserInviteRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDeleteUserInviteRequest
     */
    user_id?: string;
}

/**
 * Check if a given object implements the ControlDeleteUserInviteRequest interface.
 */
export function instanceOfControlDeleteUserInviteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ControlDeleteUserInviteRequestFromJSON(json: any): ControlDeleteUserInviteRequest {
    return ControlDeleteUserInviteRequestFromJSONTyped(json, false);
}

export function ControlDeleteUserInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDeleteUserInviteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
    };
}

export function ControlDeleteUserInviteRequestToJSON(value?: ControlDeleteUserInviteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'user_id': value.user_id,
    };
}

